export default __webpack_public_path__ + "static/media/background.b6e8f3de.svg";